import React, { useEffect, useRef } from 'react';
import Editor from '@monaco-editor/react';
import { Panel } from 'react-resizable-panels';
import { PanelGroup } from 'react-resizable-panels';
import { VerticalResizeHandle } from 'apps/sigma2-ui/src/pages/Dashboards/VerticalResizeHandle';
import * as monoco from 'monaco-editor';

export const S2MonocoEditor = ({
  code,
  setCode,
  disabled,
  language,
}: {
  code: string;
  setCode: (newCode: string) => void;
  disabled: boolean;
  language: 'python' | 'json';
}) => {
  const editorRef = useRef<monoco.editor.IStandaloneCodeEditor | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!editorRef.current) {
      return;
    }

    const checkValue = editorRef.current.getValue();
    if (code !== checkValue) {
      editorRef.current.setValue(code);
    }
  }, [code]);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    // Expose a function to Playwright
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (containerRef.current as any).__s2SetValue = (newCode: string) => {
      setCode(newCode);
    };
  }, [setCode]);

  return (
    <PanelGroup
      key={'1'}
      direction="horizontal"
      onLayout={(sizes) => {}}
      className="p-3 py-3 flex flex-grow"
    >
      <Panel
        defaultSize={500}
        minSize={27}
        className={`-m-3 vertical-resize-handle-1 flex flex-col`}
      >
        <VerticalResizeHandle
          key={'1'}
          row={1}
          chartId={'1'}
          onStopResize={async () => {}}
          initialHeight={500}
        >
          <div className="relative h-full s2-monoco-editor" ref={containerRef}>
            <div className="h-full border-2 border-black rounded-xl p-4">
              <Editor
                height="100%"
                defaultLanguage={language}
                defaultValue={code}
                onMount={(editor) => {
                  editorRef.current = editor;
                }}
                onChange={(newValue) => {
                  setCode(newValue ?? '');
                }}
              />
              {disabled && (
                <div className="absolute left-0 top-0 w-full h-full bg-gray-500 opacity-50 z-50"></div>
              )}
            </div>
          </div>
        </VerticalResizeHandle>
      </Panel>
    </PanelGroup>
  );
};
